import Link from 'next/link';
import classNames from "classnames";
import styles from './ListaProdutos.module.css';

const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
};

const ListaProdutos = () => {
    return (
        <div className={styles.containerProdutos}>
            
            <Link href="/Produtos/EnsinoSuperior/" onClick={scrollToTop} aria-labelledby="ensino-superior-link">
                <article className={styles.itemProduto}>                        
                    <div id="ensino-superior-link">
                        
                        <div tabIndex={0} className={styles.titleProduct}>
                            <span className={classNames(styles.CatProduct, styles.blue)}>Para Instituições de</span>
                            Ensino Superior  
                        </div>
                    </div>
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path d="M6.8125 0.71875C6.9375 0.5625 7.1875 0.5625 7.34375 0.71875L13.875 7.25C14.0312 7.40625 14.0312 7.625 13.875 7.78125L7.34375 14.3125C7.1875 14.4688 6.9375 14.4688 6.8125 14.3125L6.1875 13.7188C6.03125 13.5625 6.03125 13.3125 6.1875 13.1875L11.0312 8.3125H0.375C0.15625 8.3125 0 8.15625 0 7.9375V7.0625C0 6.875 0.15625 6.6875 0.375 6.6875H11.0312L6.1875 1.84375C6.03125 1.71875 6.03125 1.46875 6.1875 1.3125L6.8125 0.71875Z" fill="#0C233A"/>
                    </svg>
                </article>
            </Link>

            <Link href="/Produtos/EnsinoTecnico/" onClick={scrollToTop} aria-labelledby="ensino-tecnico-link">
                <article className={styles.itemProduto}>
                    <div id="ensino-tecnico-link">   

                        <div tabIndex={0} className={styles.titleProduct}>
                            <span className={classNames(styles.CatProduct, styles.blueLight)}>Para Instituições de</span>
                            Ensino Técnico  
                        </div>
                    </div>
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path d="M6.8125 0.71875C6.9375 0.5625 7.1875 0.5625 7.34375 0.71875L13.875 7.25C14.0312 7.40625 14.0312 7.625 13.875 7.78125L7.34375 14.3125C7.1875 14.4688 6.9375 14.4688 6.8125 14.3125L6.1875 13.7188C6.03125 13.5625 6.03125 13.3125 6.1875 13.1875L11.0312 8.3125H0.375C0.15625 8.3125 0 8.15625 0 7.9375V7.0625C0 6.875 0.15625 6.6875 0.375 6.6875H11.0312L6.1875 1.84375C6.03125 1.71875 6.03125 1.46875 6.1875 1.3125L6.8125 0.71875Z" fill="#0C233A"/>
                    </svg>
                </article>
            </Link>

            <Link href="/Produtos/Corporativo/" onClick={scrollToTop} aria-labelledby="empresa-corporativa-link">
                <article className={styles.itemProduto}>                    
                    <div id="empresa-corporativa-link">         
                                       
                        <div tabIndex={0} className={styles.titleProduct}>
                            <span className={classNames(styles.CatProduct, styles.yellow)}>Para Empresa</span>
                            Corporativo  
                        </div>
                    </div>
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path d="M6.8125 0.71875C6.9375 0.5625 7.1875 0.5625 7.34375 0.71875L13.875 7.25C14.0312 7.40625 14.0312 7.625 13.875 7.78125L7.34375 14.3125C7.1875 14.4688 6.9375 14.4688 6.8125 14.3125L6.1875 13.7188C6.03125 13.5625 6.03125 13.3125 6.1875 13.1875L11.0312 8.3125H0.375C0.15625 8.3125 0 8.15625 0 7.9375V7.0625C0 6.875 0.15625 6.6875 0.375 6.6875H11.0312L6.1875 1.84375C6.03125 1.71875 6.03125 1.46875 6.1875 1.3125L6.8125 0.71875Z" fill="#0C233A"/>
                    </svg>                    
                </article>
            </Link>
            
            {/* <Link href="/Produtos/Assinante/" onClick={scrollToTop}>
                    <div className={styles.itemProduto}>                    
                        <div>
                            <span className={classNames(styles.CatProduct, styles.purple)}>Para Você</span>
                            <div tabIndex={0} className={styles.titleProduct}>
                                Assinante 
                            </div>                            
                        </div>

                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.8125 0.71875C6.9375 0.5625 7.1875 0.5625 7.34375 0.71875L13.875 7.25C14.0312 7.40625 14.0312 7.625 13.875 7.78125L7.34375 14.3125C7.1875 14.4688 6.9375 14.4688 6.8125 14.3125L6.1875 13.7188C6.03125 13.5625 6.03125 13.3125 6.1875 13.1875L11.0312 8.3125H0.375C0.15625 8.3125 0 8.15625 0 7.9375V7.0625C0 6.875 0.15625 6.6875 0.375 6.6875H11.0312L6.1875 1.84375C6.03125 1.71875 6.03125 1.46875 6.1875 1.3125L6.8125 0.71875Z" fill="#0C233A"/>
                        </svg>                    
                    </div>
                </Link> */}

        </div>
    );
};

export default ListaProdutos;
